import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

export const companyGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot):
    Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree => {
    return localStorage.getItem("shore_token") == null || localStorage.getItem("usertype") != "Company" ? inject(Router).createUrlTree(['/login'], { queryParams: { returnUrl: state.url } }) : true;
};